import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import { alpha } from "@mui/material/styles";

export const Footer = () => (
  <>
    {/* Google Map */}
    <Box
      sx={{
        overflow: "hidden",
        width: "100%",
        height: { xs: 300, md: 420 },
      }}
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2250.041022188776!2d12.545833276401952!3d55.6708867982981!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465253c1a9bb784d%3A0x577704fad0fdd1c6!2sHoppenhagen%20Fitness%20Club!5e0!3m2!1sen!2sdk!4v1735649878476!5m2!1sen!2sdk"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        title="Hoppenhagen location map"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </Box>

    {/* Footer bar */}
    <Box
      sx={{
        backgroundColor: "primary.dark",
        width: "100%",
        py: { xs: 5, sm: 6 },
        px: { xs: 3, sm: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={{ xs: 4, sm: 2 }}
        >
          {/* Brand + copyright */}
          <Box>
            <Typography
              variant="body1"
              sx={{ color: "common.white", fontWeight: 800, mb: 0.5 }}
            >
              Hoppenhagen
            </Typography>
            <Typography variant="caption" sx={{ color: (theme) => alpha(theme.palette.common.white, 0.6) }}>
              © Hoppenhagen 2025 · Where fun meets fitness
            </Typography>
          </Box>

          {/* Contact */}
          <Stack spacing={1}>
            <Box
              component="a"
              href="mailto:hoppenhagen@gmail.com"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "common.white",
                textDecoration: "none",
                "&:hover": { opacity: 0.8 },
              }}
            >
              <EmailIcon fontSize="small" />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                hoppenhagen@gmail.com
              </Typography>
            </Box>
          </Stack>

          {/* Social icons */}
          <Stack direction="row" spacing={1}>
            <IconButton
              component="a"
              href="https://www.facebook.com/hoppenhagen.fitclub"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Hoppenhagen on Facebook"
              sx={{ color: "common.white", "&:hover": { color: "teal.light" } }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.instagram.com/hoppenhagen.fitclub/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Hoppenhagen on Instagram"
              sx={{ color: "common.white", "&:hover": { color: "teal.light" } }}
            >
              <InstagramIcon />
            </IconButton>
          </Stack>
        </Stack>
      </Container>
    </Box>
  </>
);
